import React, { useEffect, useState } from 'react'

export const loadingMessages = [
  'Training neural networks to dance...',
  'Optimizing algorithms to make coffee...',
  'Fetching data from the future...',
  'Calibrating machine learning models for world domination...',
  'Analyzing big data for fun...',
  'Syncing with the mainframe... whatever that means...',
  'Crunching the numbers... and eating cookies...',
  'Building AI insights... with a side of humor...',
  'Connecting to the quantum realm... and back...',
  'Initializing deep learning... deep thoughts incoming...',
  'Scanning for patterns... and cat videos...',
  'Integrating APIs... with a sprinkle of magic...',
  'Deploying smart solutions... and smart jokes...',
  'Running AI diagnostics... with a smile...',
  'Enhancing with artificial intelligence... and artificial smiles...',
]

function PageLoader({
  children,
  size,
  hasMessage,
}: {
  children?: React.ReactNode
  size?: number
  hasMessage?: boolean
}) {
  const [message, setMessage] = useState<string>('')

  const [opacity, setOpacity] = useState(0)

  useEffect(() => {
    if (hasMessage) {
      setOpacity(1)
    } else {
      setOpacity(0)
    }
  }, [hasMessage])

  useEffect(() => {
    if (hasMessage) {
      const randomMessage =
        loadingMessages[Math.floor(Math.random() * loadingMessages.length)]
      setMessage(randomMessage)
    }
  }, [hasMessage])

  return (
    <div
      style={{
        overflow: 'hidden',
        transition: 'opacity 1s ease-in-out',
        opacity: opacity,
      }}
    >
      {!children && (
        <div className="flex h-screen flex-col items-center justify-center">
          <Message hasMessage={true} message={message} />
        </div>
      )}
      {children && <>{children}</>}
    </div>
  )
}

export default PageLoader

const Message = ({ hasMessage, message }) => {
  return (
    <>
      {hasMessage && (
        <span className="relative inline-block animate-pulse border-y border-toasty-blue-500 bg-white px-4 py-2 text-sm font-semibold text-toasty-blue-500 shadow-2xl">
          <span className="relative">{message}</span>
        </span>
      )}
    </>
  )
}
